import { useBroadcastStorage } from './useBroadcastStorage';
import { EntityTypeEnum } from '../../gql/typings';

const generateTableLastVisitedKey = (entityType: EntityTypeEnum) => `${entityType}-last-visited`;

export const useLastVisitState = (
  entityType: EntityTypeEnum
) => useBroadcastStorage<number>(generateTableLastVisitedKey(entityType), 0);
